import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
  Button, Checkbox, Form, Input, Radio
} from 'antd';
import ReCAPTCHA from 'react-google-recaptcha';
import ReactCodeInput from 'react-code-input';
import SweetAlert from 'react-bootstrap-sweetalert';


import IntlMessages from 'util/IntlMessages';
import InfoView from 'components/common/InfoView';
import {
  userSignUp,
  activateAccount,
  resetActivateAccount,
  generateNewCode,
} from '../redux/actions/Auth';
import { showErrorMessage } from 'redux/actions/Common';
import logo from '../assets/images/kitegateway_icon_all.png';
import background from '../assets/images/bg/1.jpg';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const SignUp = ({ history }) => {
  const [acceptTermsAndConditions, toggleAcceptTermsAndConditions] = useState(false);
  const [showVerification, toggleShowVerification] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const [inputCode, setInputCode] = useState('');
  const [count, setCount] = useState(60);
  const [merchantType, setMerchantType] = useState("PSP");

  const dispatch = useDispatch();
  const {
    registrationUserId,
    token,
    activationCode,
  } = useSelector(({ auth }) => auth);
  const { data, error } = useSelector(({ auth }) => auth.activateUser);

  const onFinishFailed = (errorInfo) => {
    console.error('Failed:', errorInfo);
  };

  const onFinish = (values) => {
    values.merchant_type = merchantType;
    dispatch(userSignUp(values));
    // Reset token after 2 minutes, since thats when
    // the token expires
    setTimeout(() => {
      setCaptchaToken('');
    }, 120000);
  };

  const onConfirm = () => {
    if (inputCode && inputCode.length === 6) {
      dispatch(activateAccount({
        userId: registrationUserId,
        secretCode: inputCode,
      }));
    } else {
      const message = 'Input Code must be 6 characters';
      dispatch(showErrorMessage(message));
    }
  };

  const onMerchantTypeChange = (e) => {
    setMerchantType(e.target.value);
  };

  useEffect(() => {
    let start = Number(count);
    const end = Number(0);

    if (start === end) return;

    const incrementTime = 2000;
    const timer = setInterval(() => {
      start -= 2;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, incrementTime);
  }, [count]);

  const handleRegenerateCode = () => {
    dispatch(generateNewCode({ userId: registrationUserId }));
    setCount(60);
  };

  useEffect(() => {
    if (registrationUserId) {
      toggleShowVerification(true);
    }
  }, [dispatch, registrationUserId]);

  useEffect(() => {
    if (data && (Object.keys(data).length !== 0)) {
      toggleShowVerification(false);
      history.push('/signin');

      setTimeout(() => {
        dispatch(resetActivateAccount());
      }, 2000);
    }
    if (error) {
      const message = 'Unable to activate account';
      dispatch(showErrorMessage(message));
    }
  }, [dispatch, data, error, activationCode, history]);

  useEffect(() => {
    if (token !== null && !activationCode) {
      history.push('/');
    }
  });

  return (
    <div className="gx-app-login-wrap" style={{ backgroundImage: `url(${background})` }}>
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
          <div className="gx-app-logo-content">
            <div className="gx-app-logo-content-bg" />
            <div className="gx-app-logo-wid">
              <h1>
                <IntlMessages id="app.userAuth.signUp" />
              </h1>
              <p>
                <IntlMessages id="app.userAuth.bySigning" />
              </p>
              <p>
                <IntlMessages id="app.userAuth.getAccount" />
              </p>
            </div>
            <div className="gx-app-logo">
              <img
                src={logo}
                alt="Kitegateway"
                title="Kitegateway"
              />
            </div>
          </div>

          <div className="gx-app-login-content">
            <Form
              initialValues={{ remember: true }}
              name="basic"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              className="gx-signin-form gx-form-row0"
            >
              <Form.Item
                name="merchant_type"
              // rules={[
              //   {
              //     required: true,
              //     type: 'merchant_type',
              //     message: 'Please select your merchant type!',
              //   },
              // ]}
              >
                <p> Account Type </p>
                <RadioGroup onChange={onMerchantTypeChange} defaultValue="psp">
                  <RadioButton value="PSP">PSP</RadioButton>
                  <RadioButton value="BUSINESS">Business</RadioButton>
                  <RadioButton value="AFFILIATE">Affiliate</RadioButton>
                </RadioGroup>
              </Form.Item>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: 'Please input your Password!' },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item>
                <Checkbox
                  onChange={() => toggleAcceptTermsAndConditions(!acceptTermsAndConditions)}
                  className="signup-checkbox"
                >
                  <IntlMessages id="appModule.iAccept" />
                </Checkbox>
                <span className="gx-signup-form-forgot gx-link">
                  <IntlMessages id="appModule.termAndCondition" />
                </span>
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
                  onChange={setCaptchaToken}
                  onExpired={() => setCaptchaToken('')}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  className={`gx-mb-0 ${(acceptTermsAndConditions && captchaToken) ? 'enabled' : 'disabled'
                    }`}
                  htmlType={(acceptTermsAndConditions && captchaToken) ? 'submit' : 'button'}
                >
                  <IntlMessages id="app.userAuth.signUp" />
                </Button>
                <span>
                  <IntlMessages id="app.userAuth.or" />
                </span>
                {' '}
                <Link to="/signin" className="gx-text-kitegateway-blue">
                  <IntlMessages id="app.userAuth.signIn" />
                </Link>
              </Form.Item>
            </Form>
          </div>
          <SweetAlert
            show={showVerification}
            type="controlled"
            title={<IntlMessages id="app.userAuth.verificationTitle" />}
            onConfirm={onConfirm}
            afterMount={() => setCount(60)}
            customClass="gx-sweet-alert-top-space"
          >
            <IntlMessages id="app.userAuth.verificationDescription" />
            {registrationUserId
              && (
                <div>
                  <br />
                  <p>
                    If you haven&apos;t got the code sent to your email,
                    you can generate another code
                    {(count !== 0) ? ` in ${count} seconds.` : ' now.'}
                  </p>
                  <Button
                    type="primary"
                    onClick={() => handleRegenerateCode()}
                    disabled={(count !== 0)}
                  >
                    Resend Code
                  </Button>
                </div>
              )}
            <ReactCodeInput
              onChange={(code) => setInputCode(code)}
              type="text"
              fields={6}
              value={inputCode}
            />
          </SweetAlert>
        </div>
      </div>
      <InfoView />
    </div>
  );
};

SignUp.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default SignUp;
